import { render, staticRenderFns } from "./OpportunityMetaCard.vue?vue&type=template&id=78426856"
import script from "./OpportunityMetaCard.vue?vue&type=script&lang=js"
export * from "./OpportunityMetaCard.vue?vue&type=script&lang=js"
import style0 from "./OpportunityMetaCard.vue?vue&type=style&index=0&id=78426856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports